import React, { useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import * as S from './AdminDashboard.style';

import { PlusCircle, LogOutIcon } from 'lucide-react';
import { UrbanCompassLogoBlack } from '../../../icons';

import QuestionCard from './questionCard';
import AddQuestionModal from './modals/addQuestionModal';

const Header = ({ onAddClick, onLogout }) => {
  return (
    <S.Header>
      <S.Logo>
        <UrbanCompassLogoBlack
          style={{ width: '62px', height: '32px', justifySelf: 'flex-start' }}
        />
        <S.Title>
          <span style={{ color: 'rgb(78 50 240)' }}>Admin</span> Dashboard
        </S.Title>
      </S.Logo>
      <S.Logo>
        <S.AddButton onClick={onAddClick}>
          <PlusCircle size={20} />
          Add Question
        </S.AddButton>
        <S.AddButton onClick={onLogout}>
          <LogOutIcon /> Log out
        </S.AddButton>
      </S.Logo>
    </S.Header>
  );
};

const TabNav = ({ activeTab, onTabChange }) => {
  return (
    <S.TabList>
      <S.Tab active={activeTab === 'all'} onClick={() => onTabChange('all')}>
        All Questions
      </S.Tab>
      <S.Tab active={activeTab === 'mcq'} onClick={() => onTabChange('mcq')}>
        Multiple Choice
      </S.Tab>
      <S.Tab active={activeTab === 'text'} onClick={() => onTabChange('text')}>
        Text Questions
      </S.Tab>
    </S.TabList>
  );
};

const AdminDashboard = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('all');
  const [showAddModal, setShowAddModal] = useState(false);

  const handleLogout = () => {
    navigate('/');
    logout();
  };

  const handleAddQuestion = (newQuestion) => {
    console.log('api called', newQuestion);
  };

  return (
    <S.DashboardContainer>
      <Header onAddClick={() => setShowAddModal(true)} onLogout={handleLogout} />

      <S.TabContainer>
        <TabNav activeTab={activeTab} onTabChange={setActiveTab} />

        <div>
          <QuestionCard />
        </div>
      </S.TabContainer>

      {showAddModal && (
        <AddQuestionModal onClose={() => setShowAddModal(false)} onSubmit={handleAddQuestion} />
      )}
    </S.DashboardContainer>
  );
};

export default AdminDashboard;
